import { useMemo } from "react";
import { getMulticallContract } from "./contractHelper";
import { CHAIN_ID } from "./connectors";

export const MulticallContract = (chainId = CHAIN_ID) => {
  return useMemo(() => {
    return getMulticallContract(chainId);
  }, []);
} 
